/**
 * The batch table's binding of the shared detail-page surface.
 *
 * Everything structural — the shell, the drag, the rail, the persistence —
 * lives in `shared/surface`. This file is the whole of what tables add: their
 * config (`./layout`) and one typed hook over the generic one.
 */

import useDetailSurface, {
  UseDetailSurfaceOptions,
  UseDetailSurfaceResult,
} from '../../shared/surface/useDetailSurface';
import { TABLE_SURFACE, TablePanelId } from './layout';
import { TableItemKind } from './TableSurfaceContext';

export { TABLE_SURFACE };
export type { TablePanelId };

export type TableWorkspace = UseDetailSurfaceResult<TablePanelId, TableItemKind, never>;

/**
 * The table page's layout and cell selection.
 *
 * Takes the table id because the arrangement is remembered per table — see the
 * note at the top of `./layout`.
 */
export const useTableWorkspace = (
  tableId: string,
  options: Omit<UseDetailSurfaceOptions, 'entityId'> = {}
): TableWorkspace =>
  useDetailSurface<TablePanelId, TableItemKind, never>(TABLE_SURFACE, {
    ...options,
    entityId: tableId,
  });
